import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SubmitHandler, useForm } from "react-hook-form";

import useAuth from "../../hooks/useAuth";

import { EmitError } from "../../utils/EmitError";
import { urlHttpGov } from "../../services/urls";
import PanelUserAccessRecovery from "../../services/http/services/PanelUserAccessRecovery";
import { notification } from "antd";

export default function useRecoveryPassword() {
    const {
        loading: isLoadingUser,
        user,
    } = useAuth();

    const { code } = useParams();

    const navigate = useNavigate();
    const formRef = useRef<any>(null);

    const [isSubmiting, setIsSubmiting] = useState(false);
    const [pathBackgroundImage, setPathBackgroundImage] = useState<string>('');

    const {
        control,
        handleSubmit,
        formState: { errors, },
        reset,
        setError,
    } = useForm<{ password: string; confirmPassword: string }>({
        defaultValues: {
            password: '',
            confirmPassword: '',
        }
    });

    useEffect(() => {
        if (user) {
            navigate('/dashboard');
        }
    }, [user, navigate]);


    const onSubmit: SubmitHandler<{ password: string, confirmPassword: string }> = useCallback(async (data) => {
        if (data.password !== data.confirmPassword) {
            setError('confirmPassword', { message: 'Senhas não coincidem' });
            return;
        }

        try {
            setIsSubmiting(true);
            const response = await PanelUserAccessRecovery.resetPassword({ code: code || '', password: data.password });

            setIsSubmiting(false);

            if (!response) {
                return;
            }
            notification.success({
                message: 'Sucesso!',
                description: response.msg,
                placement: 'topRight'
            })

            reset();

            navigate('/');
        } catch (error) {
            setIsSubmiting(false);

            EmitError(error, true, 'login_dkwdfaiweyi')
        }
    }, [navigate, reset, code, setError]);

    useEffect(() => {
        let dataPathBackground: string | null = localStorage.getItem('@NotaMunicipio:background');
        const defaultPath = `${urlHttpGov}/logo_county/background-default.jpg`;

        if (typeof dataPathBackground == 'string') {
            let path: string = JSON.parse(dataPathBackground).path;

            if (path.includes('undefined')) {
                path = defaultPath;
            }

            setPathBackgroundImage(path);
            return;
        }
        setPathBackgroundImage(defaultPath);
    }, []);

    return {
        isLoadingUser,
        user,
        isSubmiting,
        formRef,
        control,
        handleSubmit,
        errors,
        onSubmit,
        pathBackgroundImage,
    }
}
